import { useCallback, useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useChannelScrapingWorkerServers } from '@/hooks/useChannelScraping';

export const SCRAPING_SERVER_QUERY_PARAM = 'scrapingServerId';

export const useSelectedScrapingServer = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { data: scrapingServers = [], isLoading } = useChannelScrapingWorkerServers();
  const enabledServers = useMemo(
    () => scrapingServers.filter((server) => server.enabled !== false),
    [scrapingServers]
  );
  const selectedScrapingServerId = searchParams.get(SCRAPING_SERVER_QUERY_PARAM) || enabledServers[0]?.id || null;
  const selectedScrapingServer = scrapingServers.find((server) => server.id === selectedScrapingServerId) || null;

  useEffect(() => {
    if (searchParams.get(SCRAPING_SERVER_QUERY_PARAM) || !enabledServers[0]?.id) {
      return;
    }
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set(SCRAPING_SERVER_QUERY_PARAM, enabledServers[0].id);
    setSearchParams(nextParams, { replace: true });
  }, [enabledServers, searchParams, setSearchParams]);

  const setSelectedScrapingServerId = useCallback((serverId: string) => {
    const nextParams = new URLSearchParams(searchParams);
    if (serverId) {
      nextParams.set(SCRAPING_SERVER_QUERY_PARAM, serverId);
    } else {
      nextParams.delete(SCRAPING_SERVER_QUERY_PARAM);
    }
    setSearchParams(nextParams);
  }, [searchParams, setSearchParams]);

  return {
    enabledScrapingServers: enabledServers,
    scrapingServers,
    isScrapingServersLoading: isLoading,
    selectedScrapingServer,
    selectedScrapingServerId,
    setSelectedScrapingServerId,
  };
};
